<template>
  <el-drawer
    title="参与活动详情"
    size="80%"
    @close="drClose"
    :visible.sync="visible"
  >
    <div class="content">
      <WtDataList
        v-if="visible"
        v-model="data.list"
        :url="$url.activity.apply.viewList"
        :pageSize="10"
        :search="search"
        ref="ativityApplyTables"
      >
        <div slot="list">
          <el-table :data="data.list" ref="table">
            <el-table-column
              label="活动名称"
              prop="activity_name"
            ></el-table-column>
            <el-table-column label="活动时间" width="150">
              <template slot-scope="scope">
                <span>{{
                  scope.row.activity_info_start || scope.row.activity_info_end
                    ? (scope.row.activity_info_start || "") +
                      (scope.row.activity_info_end
                        ? "~" + scope.row.activity_info_end
                        : "")
                    : "--"
                }}</span>
              </template></el-table-column
            >
            <el-table-column
              label="活动类型"
              width="150"
              prop="type_text"
            ></el-table-column>
            <el-table-column
              label="报名时间"
              width="170"
              prop="created_at"
            ></el-table-column>
            <el-table-column label="服务时长(h)" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.activity_service_length || "--" }}</span>
              </template></el-table-column
            >
            <el-table-column label="审核状态" align="center" width="100">
              <template slot-scope="scope">
                <span
                  :style="{ color: auditStatusColor[scope.row.audit_status] }"
                  >{{ scope.row.audit_status_text }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </WtDataList>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    searchData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      data: {},
      search: {},
      auditStatusColor: {
        1: "#ff9900",
        2: "#00cc66",
        3: "red",
      },
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        this.search = Object.assign(this.search, this.searchData);
      }
    },
    visible(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    drClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .page-box {
  margin-top: 16px !important;
}
.content {
  border-top: 1px solid #eee;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/college/components/activityApplyList.vue